import { EticatType, HubFeature } from '@ats/api/cm';
import { LocDefs, LocMap, MapLocKeys } from '../../models';
import { SYSTEM_ENUM_ROOT } from '../shared-data';

const dpRoot = `${SYSTEM_ENUM_ROOT}|ECommerce|E-Transaction Item Catalog Type`;

export type CPETransactionItemCatTypeLocs =
	| 'CPETransactionItemCatTypeEnumCrcat'
	| 'CPETransactionItemCatTypeEnumFcat'
	| 'CPETransactionItemCatTypeEnumNone';

export type SPETransactionItemCatTypeLocs =
	| 'SPETransactionItemCatTypeEnumCrcat'
	| 'SPETransactionItemCatTypeEnumFcat'
	| 'SPETransactionItemCatTypeEnumNone';

export const cpETransactionItemCatTypeEnumLocs: LocDefs<CPETransactionItemCatTypeLocs> = {
	CPETransactionItemCatTypeEnumCrcat: {
		defaultValue: 'Certification Requirement',
		displayPath: `${dpRoot}|${EticatType.Crcat}`,
		description: `System value for e-transaction item catalog type: '${EticatType.Crcat}'`,
		displayType: 'Content',
		feature: HubFeature.Ecommerce,
		portal: 'CP',
	},
	CPETransactionItemCatTypeEnumFcat: {
		defaultValue: 'Fulfillment',
		displayPath: `${dpRoot}|${EticatType.Fcat}`,
		description: `System value for e-transaction item catalog type: '${EticatType.Fcat}'`,
		displayType: 'Content',
		feature: HubFeature.Ecommerce,
		portal: 'CP',
	},
	CPETransactionItemCatTypeEnumNone: {
		defaultValue: 'None',
		displayPath: `${dpRoot}|${EticatType.None}`,
		description: `System value for e-transaction item catalog type: '${EticatType.None}'`,
		displayType: 'Content',
		feature: HubFeature.Ecommerce,
		portal: 'CP',
	},
};

export const spETransactionItemCatTypeEnumLocs: LocDefs<SPETransactionItemCatTypeLocs> = {
	SPETransactionItemCatTypeEnumCrcat: {
		defaultValue: 'Certification Requirement',
		displayPath: `${dpRoot}|${EticatType.Crcat}`,
		description: `System value for e-transaction item catalog type: '${EticatType.Crcat}'`,
		displayType: 'Content',
		feature: HubFeature.Ecommerce,
		portal: 'SP',
	},
	SPETransactionItemCatTypeEnumFcat: {
		defaultValue: 'Fulfillment',
		displayPath: `${dpRoot}|${EticatType.Fcat}`,
		description: `System value for e-transaction item catalog type: '${EticatType.Fcat}'`,
		displayType: 'Content',
		feature: HubFeature.Ecommerce,
		portal: 'SP',
	},
	SPETransactionItemCatTypeEnumNone: {
		defaultValue: 'None',
		displayPath: `${dpRoot}|${EticatType.None}`,
		description: `System value for e-transaction item catalog type: '${EticatType.None}'`,
		displayType: 'Content',
		feature: HubFeature.Ecommerce,
		portal: 'SP',
	},
};

const E_TRANSACTION_STATE_LOCS = MapLocKeys<
	CPETransactionItemCatTypeLocs | SPETransactionItemCatTypeLocs
>({
	...cpETransactionItemCatTypeEnumLocs,
	...spETransactionItemCatTypeEnumLocs,
});

export type CPETransactionItemCatEnumLocType = LocMap<CPETransactionItemCatTypeLocs>;
export type SPETransactionItemCatEnumLocType = LocMap<SPETransactionItemCatTypeLocs>;

export const cpETransactionItemCatTypeKeys: {
	[key in EticatType]: keyof CPETransactionItemCatEnumLocType;
} = {
	[EticatType.Crcat]: E_TRANSACTION_STATE_LOCS.CPETransactionItemCatTypeEnumCrcat,
	[EticatType.Fcat]: E_TRANSACTION_STATE_LOCS.CPETransactionItemCatTypeEnumFcat,
	[EticatType.None]: E_TRANSACTION_STATE_LOCS.CPETransactionItemCatTypeEnumNone,
};

export const spETransactionItemCatTypeKeys: {
	[key in EticatType]: keyof SPETransactionItemCatEnumLocType;
} = {
	[EticatType.Crcat]: E_TRANSACTION_STATE_LOCS.SPETransactionItemCatTypeEnumCrcat,
	[EticatType.Fcat]: E_TRANSACTION_STATE_LOCS.SPETransactionItemCatTypeEnumFcat,
	[EticatType.None]: E_TRANSACTION_STATE_LOCS.SPETransactionItemCatTypeEnumNone,
};
